import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.collapsed = localStorage.getItem("sidebarCollapsed") === "true"
    this.updateSidebarState()
  }

  toggle() {
    this.collapsed = !this.collapsed
    localStorage.setItem("sidebarCollapsed", this.collapsed)
    this.updateSidebarState()
  }

  updateSidebarState() {
    if (this.collapsed) {
      this.element.setAttribute("data-collapsed", "true")
    } else {
      this.element.setAttribute("data-collapsed", "false")
    }
  }
}
